export const ORIGINAL_SKELETON_COUNT = 9
export const ORIGINAL_PLAY_GAMES_PER_CAROUSEL = 9
export const ORIGINAL_BET_HISTORY_PER_PAGE = 10

export const MINE_BOARD_SIZE = 25
export const MINE_BOARD_COLUMNS = 5

export const CHICKEN_DIFFICULTIES = ['easy', 'medium', 'hard', 'hardcore'] as const

export const BACCARAT_CHIP_COLORS = ['#4caf50', '#2196f3', '#00bcd4', '#8bc34a', '#ffeb3b', '#ff9800', '#f44336']
export const BACCARAT_CHIP_RATIO = 100_000
export const BACCARAT_CHIP_RAW_VALUES = [1, 10, 100, 1_000, 10_000, 100_000, 1_000_000]
export const BACCARAT_CHIP_REAL_VALUES = [0.00001, 0.0001, 0.001, 0.01, 0.1, 1, 10]
export const BACCARAT_DEFAULT_CHIP_INDEX = 5

export const ROULETTE_CHIP_COLORS = ['#4caf50', '#2196f3', '#00bcd4', '#8bc34a', '#ffeb3b', '#ff9800', '#f44336']
export const ROULETTE_CHIP_RATIO = 100_000
export const ROULETTE_CHIP_RAW_VALUES = [1, 10, 100, 1_000, 10_000, 100_000, 1_000_000]
export const ROULETTE_CHIP_REAL_VALUES = [0.00001, 0.0001, 0.001, 0.01, 0.1, 1, 10]
export const ROULETTE_DEFAULT_CHIP_INDEX = 5

export const ROULETTE_WHEEL_NUMBERS = [
	{ number: 0, color: 'Green' },
	{ number: 32, color: 'Red' },
	{ number: 15, color: 'Black' },
	{ number: 19, color: 'Red' },
	{ number: 4, color: 'Black' },
	{ number: 21, color: 'Red' },
	{ number: 2, color: 'Black' },
	{ number: 25, color: 'Red' },
	{ number: 17, color: 'Black' },
	{ number: 34, color: 'Red' },
	{ number: 6, color: 'Black' },
	{ number: 27, color: 'Red' },
	{ number: 13, color: 'Black' },
	{ number: 36, color: 'Red' },
	{ number: 11, color: 'Black' },
	{ number: 30, color: 'Red' },
	{ number: 8, color: 'Black' },
	{ number: 23, color: 'Red' },
	{ number: 10, color: 'Black' },
	{ number: 5, color: 'Red' },
	{ number: 24, color: 'Black' },
	{ number: 16, color: 'Red' },
	{ number: 33, color: 'Black' },
	{ number: 1, color: 'Red' },
	{ number: 20, color: 'Black' },
	{ number: 14, color: 'Red' },
	{ number: 31, color: 'Black' },
	{ number: 9, color: 'Red' },
	{ number: 22, color: 'Black' },
	{ number: 18, color: 'Red' },
	{ number: 29, color: 'Black' },
	{ number: 7, color: 'Red' },
	{ number: 28, color: 'Black' },
	{ number: 12, color: 'Red' },
	{ number: 35, color: 'Black' },
	{ number: 3, color: 'Red' },
	{ number: 26, color: 'Black' },
] as const

export const SLIDE_STRIP_LENGTH = 50
export const SLIDE_SPIN_PX_PER_SECOND = 1500
export const SLIDE_DECELERATION_SECONDS = 1.2

export const SLIDE_TILE_DEFINITIONS = [
	{ tier: 'dark' as const, color: '#2d4454', textColor: 'white', point: 0, spriteColumns: 11, spriteRows: 3 },
	{ tier: 'white' as const, color: '#dcdfe4', textColor: 'black', point: 2, spriteColumns: 10, spriteRows: 4 },
	{ tier: 'blue' as const, color: '#017bff', textColor: 'white', point: 5, spriteColumns: 10, spriteRows: 4 },
	{ tier: 'orange' as const, color: '#ff9d00', textColor: 'black', point: 10, spriteColumns: 10, spriteRows: 4 },
	{ tier: 'green' as const, color: '#00e701', textColor: 'white', point: 100, spriteColumns: 10, spriteRows: 4 },
	{ tier: 'diamond' as const, color: '#50e3c2', textColor: 'white', point: 1000, spriteColumns: 7, spriteRows: 7 },
] as const
